import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { toggleFullscreenView } from '../../actions'
import VideoContainer from './VideoContainer'
import LayoutPagination from './LayoutPagination'
import UnsavedViewModal from './UnsavedViewModal'

const Live = props => {
  const [displayCams, setDisplayCams] = useState([]);
  const [videoContainerSize, setVideoContainerSize] = useState({});
  const [contextMenu, setContextMenu] = useState([])

  const {
    layoutConfig,
    camset,
    selectedSingleViewCam,
    fullscreenView,
    showUnsavedViewModal,
    selectedUserView,
    cameras,
    compositeCams,
    toggleFullscreenView,
  } = props;

  // support for 16 cameras in view

  useEffect(() => {
    const calculateDisplayCams = () => {
      let dCams;
      if(layoutConfig === '1'){
        dCams = [compositeCams[camset]];
      };

      if(layoutConfig === '4'){
        if(camset === 0){
          dCams = compositeCams.slice(0,4);
        };
        if(camset === 1){
          dCams = compositeCams.slice(4,8);
        };
        if(camset === 2){
          dCams = compositeCams.slice(8,10);
        };
        if(camset === 3){
          dCams = compositeCams.slice(12,16);
        };
      };

      if(layoutConfig === '6'){
        if(camset === 0){
          dCams = compositeCams.slice(0,6);
        };
        if(camset === 1){
          dCams = compositeCams.slice(6,12);
        };
        if(camset === 2){
          dCams = compositeCams.slice(12,18);
        };
      };

      if(layoutConfig === '9'){
        if(camset === 0){
          dCams = compositeCams.slice(0,9);
        };
        if(camset === 1){
          dCams = compositeCams.slice(9,18);
        };
      };

      if(layoutConfig === '12'){
        if(camset === 0){
          dCams = compositeCams.slice(0,12);
        };
        if(camset === 1){
          dCams = compositeCams.slice(12,24);
        };
      };

      if(layoutConfig === '16'){
        if(camset === 0){
          dCams = compositeCams.slice(0,16);
        };
        if(camset === 1){
          dCams = compositeCams.slice(16,32);
        };
      };

      setDisplayCams(dCams);
    }
    calculateDisplayCams()

    let size = {}
    switch (layoutConfig) {
      case '4': size = {width: '50%', height: '50%'}
        break
      case '6': size = {width: '33.3%', height: '50%'}
        break
      case '9': size = {width: '33.3%', height: '33.3%'}
        break
      case '12': size = {width: '25%', height: '33.3%'}
        break
      case '16': size = {width: '25%', height: '25%'}
        break
      default: size = {width: '100%', height: '100%'}
        break
    }
    setVideoContainerSize(size)

  }, [compositeCams, camset, layoutConfig])

  const onRightClick = (e) => {
    e.preventDefault()
    if (fullscreenView) {
      setContextMenu([e.clientY, e.clientX])
    }
  }

  const closeFullscreen = () => {
    setContextMenu([])
    toggleFullscreenView()
  }

  return (
    <div style={styles.container} >
      <div onContextMenu={onRightClick} style={{...styles.videoGridContainer, position: fullscreenView ? 'absolute' : 'relative', backgroundColor: fullscreenView ? 'rgba(10, 14, 25, 1)' : 'rgba(10, 14, 25, 0.6)'}}>
        { Object.keys(selectedSingleViewCam).length
          ? // display single view camera
            <VideoContainer camera={selectedSingleViewCam} single={true} size={videoContainerSize} />

          : layoutConfig === '1'
            ? <VideoContainer camera={cameras.find(camera => camera.bID === displayCams[0])} single={true} size={videoContainerSize} />

            : Array.from(Array(parseInt(layoutConfig))).map((_, index) => {
                // find the target camera
                const camId = displayCams[index]
                let targetCam = cameras.find(camera => camera.bID === camId);

                return (
                  <div key={index} style={{...styles.videoContainer, ...videoContainerSize}}>
                    <VideoContainer key={index} slotId={index} camera={targetCam} size={videoContainerSize} />
                  </div>
                )
              })
        }
        {contextMenu.length > 1 && <div style={{...styles.contextMenu, top: contextMenu[0], left: contextMenu[1]}} onClick={closeFullscreen}>Exit Fullscreen</div>}
      </div>

      {showUnsavedViewModal && <UnsavedViewModal view={selectedUserView} />}
      <LayoutPagination />
    </div>
  )
}

const mapStateToProps = state => {
    const { layoutConfig, camset } = state.config;
    const { selectedSingleViewCam, fullscreenView, showUnsavedViewModal } = state.live;
    const { selectedUserView, devices, cameras } = state.data

    return {
      layoutConfig,
      camset,
      selectedSingleViewCam,
      fullscreenView,
      showUnsavedViewModal,
      selectedUserView,
      devices,
      cameras,
      compositeCams: state.data.compositeCams && state.data.compositeCams.length > 0 ? [...state.data.compositeCams].filter(cc => cc === 0 ? {} : cameras.find(c => (c.bID === cc && c.fEnabled === 1))) : [],
    }
};

export default connect(mapStateToProps, { toggleFullscreenView })(Live);

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '75vw',
  },
  videoGridContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    height: '100%',
    width: '100%',
    border: '1px solid lightgrey',
    top: 0,
    left: 0,
  },
  videoContainer: {
    border: '1px solid grey',
  },
  contextMenu: {
    position: 'absolute',
    zIndex: 100,
    backgroundColor: 'lightgrey',
    cursor: 'pointer',
    fontSize: '1.4vmin',
    padding: 20,
  },
  modal: {
    position: 'absolute',
    top: 0,
    left: 0 ,
    width: '100%',
    height: '100%'
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    fontSize: '1.6vmin',
    textAlign: 'left',
  },
}